import Markdown from 'react-markdown';
import remarkGfm from 'remark-gfm';

const SAFE_URL = /^(https?:|mailto:)/i;

/** Claude's answers as Markdown: no raw HTML, no script URLs, no images fetched from answers. */
export function SafeMarkdown({ text }: { text: string }): React.JSX.Element {
  return (
    <Markdown
      remarkPlugins={[remarkGfm]}
      skipHtml
      urlTransform={(url) => (SAFE_URL.test(url) ? url : '')}
      components={{
        a: ({ href, children }) =>
          href ? (
            <a href={href} target="_blank" rel="noopener noreferrer">
              {children}
            </a>
          ) : (
            <span>{children}</span>
          ),
        img: ({ alt, src }) => <span>{alt || (typeof src === 'string' ? src : '')}</span>,
      }}
    >
      {text}
    </Markdown>
  );
}
